export interface FormatDateTimeOptions {
  readonly locale?: string;
  readonly fallback?: string;
  readonly keepInvalid?: boolean;
}

export function formatDateTime(
  value: string | Date | null | undefined,
  options: FormatDateTimeOptions = {},
): string {
  const fallback = options.fallback ?? '—';
  if (value === null || value === undefined) return fallback;
  if (typeof value === 'string' && value.trim().length === 0) return fallback;

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    if (options.keepInvalid === true && typeof value === 'string') {
      return value;
    }
    return fallback;
  }

  const explicitLocale = options.locale;
  const locale =
    typeof explicitLocale === 'string' && explicitLocale.trim().length > 0
      ? explicitLocale
      : undefined;
  if (typeof locale === 'string') {
    return date.toLocaleString(locale);
  }
  return date.toLocaleString();
}
